import { createAction } from "@reduxjs/toolkit";

export const setMobileDevice = createAction("IS_MOBILE");
export const setTabletDevice = createAction("IS_TABLET");

